<template>
  <!-- 班级课表 -->
  <div class="my-course">
    <van-list v-model="loading" :finished="finished" :finished-text="finishText" @load="handleGetPostList">
      <ul class="course-menu" v-if="courseList.length > 0">
        <li class="menu-li" v-for="(item, index) in courseList" :key="index">
          <div class="menu-li-head " :class="item.isDropDown ? 'li-main-br' : ''">
            <div class="li-head" @click="handleClassDropDown(item, index)">
              <p class="courseName">{{ item && item.templateName }}</p>
              <div class="icon-down">
                <img src="@/assets/images/grade/drop-up.png" alt="" class="icon-down" v-if="item && item.isDropDown" />
                <img src="@/assets/images/grade/drop-down.png" alt="" class="icon-down" v-else />
              </div>
            </div>
            <div class="li-main" @click.stop="handleOneChange(item, index)">
              <img src="@/assets/images/grade/select.png" alt="" class="icon-select" v-if="item && item.isSelected" />
              <img src="@/assets/images/teacher-task/un-select.png" class="icon-select" alt="" v-else />
              <ul class="main-menu">
                <li class="main-li">
                  <i class="icon-ill"></i>
                  <p class="ill-title">{{ item && item.disease }}</p>
                </li>
                <li class="main-li">
                  <i class="icon-new"></i>
                  <p class="ill-title">{{ item && item.newTechnology }}</p>
                </li>
              </ul>
            </div>
            <template v-if="!item.isDropDown">
              <div class="li-week" v-for="(aitem, aindex) in item.weeks" :key="aindex">
                <div class="week-left">
                  <p class="week-title">week 0{{ aitem && aitem.week }}</p>
                </div>
              </div>
            </template>
          </div>
          <template v-if="item && item.isDropDown">
            <div class="week-box" v-for="(aitem, aindex) in  item.weeks" :key="aindex"
              @click.stop="handleCourseDorpDown(aitem, index, aindex)">
              <div class="li-week">
                <div class="week-left">
                  <p class="week-title">week 0{{ aitem && aitem.week }}</p>
                </div>
                <div class="week-right">
                  <p class="down-title">
                    {{ aitem.isSwitch ? '收起' : '展开' }}
                  </p>
                  <img src="@/assets/images/grade/drop-up.png" alt="" class="icon-down" v-if="aitem.isSwitch" />
                  <img src="@/assets/images/grade/drop-down.png" alt="" class="icon-down" v-else />
                </div>
              </div>
              <template v-if="aitem.isSwitch">
                <div class="day-box" v-if="aitem.templatesContent.length">
                  <div class="day-item" v-for="(acc, cindex) in aitem.templatesContent" :key="cindex">
                    <img src="../../../assets/images/grade/icon-doast.png" alt="" class="icon-doast" />
                    <div class="day-item-box">
                      <p class="day-num">Day{{ acc.day }}</p>
                      <div class="day-main" v-for="(item_course, index_course) in acc.docuCourseCase" :key="index_course">
                        <p class="box-title">{{ item_course.title }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="empty-block" v-else>
                  <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
                  <div class="empty-txt">暂无内容</div>
                </div>
              </template>
            </div>
          </template>
        </li>
      </ul>
      <div class="empty-block" v-else-if="isNone">
        <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
        <div class="empty-txt">暂无内容</div>
      </div>
    </van-list>
    <div class="confirm-btn" @click="handleSave">确定</div>
  </div>
</template>

<script>
import { templateList } from '@/api/grade.js'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      templateId: '',
      courseList: [],
      loading: false,
      finished: false,
      pageObj: {
        pageNum: 1,
        pageSize: 10
      },
      isNone: false,
      finishText: '没有更多了'
    }
  },
  mounted () {
    this.templateId = this.createGradeJSON.templateId
    this.templateName = this.createGradeJSON.templateName
  },
  computed: {
    createGradeJSON () {
      return JSON.parse(`${sessionStorage.getItem('createGrade')}`)
    },
    templateIdUri () {
      return this.$route.query.templateId
    }
  },
  methods: {
    handleGetPostList () {
      templateList(this.pageObj)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.loading = false
              this.finished = true
              return false
            }
            this.loading = false
            res.data.list.map(item => {
              item.isSelected = !!(this.templateIdUri && item.id === this.templateIdUri)
              item.isDropDown = false
              if (item.weeks && item.weeks.length > 0) {
                item.weeks = item.weeks.map(itm => {
                  itm.isSwitch = false
                  return itm
                })
              }
              return item
            })
            if (res.data.list.length < this.pageObj.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.courseList = this.courseList.concat(res.data.list)
            }
            this.pageObj.pageNum++
            if (this.courseList.length === 0) {
              this.isNone = true
              this.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    },
    handleGo () {
      this.createGradeJSON.templateId = this.templateId
      this.createGradeJSON.templateName = this.templateName
      sessionStorage.setItem('createGrade', JSON.stringify(this.createGradeJSON))
      this.$router.go(-1)
    },
    handleSave () {
      if (this.templateIdUri) {
        this.$dialog.confirm({ message: '您已确认新模板，是否根据模板重新导入课程？' })
          .then(() => {
            this.createGradeJSON.reimport = true
            this.handleGo()
          })
          .catch(() => {
            this.createGradeJSON.reimport = false
            this.handleGo()
          })
      } else {
        this.handleGo()
      }
    },
    // 下拉展开
    handleClassDropDown (item, index) {
      this.courseList[index].isDropDown = !this.courseList[index].isDropDown
    },
    // 星期收起展开
    handleCourseDorpDown (item, index, aindex) {
      this.courseList[index].weeks[aindex].isSwitch = !this.courseList[index].weeks[aindex].isSwitch
    },
    handleOneChange (item, index) {
      this.courseList.forEach(acc => {
        if (acc.id === item.id) {
          this.templateId = item.id
          this.templateName = item.templateName
          acc.isSelected = true
        } else {
          acc.isSelected = false
        }
      })
      this.$forceUpdate()
    },
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-course {
  position: relative;
  background: #F9F8F7;
  min-height: 100vh;
  padding: 12px 10px 16px;
  box-sizing: border-box;
  z-index: 2;
  display: flex;
  flex-direction: column;
  .van-list {
    padding-bottom: 40px;
  }

  .course-menu {
    // height: calc(100vh - 80px);
    // overflow-y: scroll;
    list-style: none;
    position: relative;
    width: 100%;
    min-height: 114px;
    border-radius: 12px;

    .menu-li {
      margin-bottom: 10px;
      position: relative;
      background: #FFFFFF;
      border-radius: 12px;

      .menu-li-head {
        padding: 10px 18px 10px 8px;

        .li-head {
          display: flex;
          align-items: center;

          .courseName {
            flex: 1;
            margin-left: 22px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 600;
            font-size: 14px;
            color: #282828;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .icon-down {
            width: 13px;
            height: 7px;
            margin-right: 4px;
            display: block;
          }
        }

        .li-main {
          position: relative;
          display: flex;
          margin-top: 4px;

          .icon-select {
            width: 14px;
            height: 14px;
            margin-right: 8px;

          }

          .main-menu {
            flex: 1;
            display: flex;

            flex-direction: column;
            position: relative;

            .main-li {
              display: flex;
              // align-items: center;
              position: relative;

              .icon-ill {
                background: url('../../../assets/images/grade/icon-illness2.png') no-repeat center center / 100% 100%;
                width: 24px;
                height: 17px;
                margin-right: 4px;
                display: block;
              }

              .ill-title {
                flex: 1;
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 12px;
                color: #000000;
                overflow: hidden;
              }

              .icon-new {
                background: url('../../../assets/images/grade/icon-new-technology.png') no-repeat center center / 100% 100%;
                width: 36px;
                height: 17px;
                margin-right: 4px;
              }
            }
          }
        }
      }

      .li-main-br {
        border-bottom: 1px solid #F0F1F6;
      }

      .li-week {
        background: url("../../../assets/images/grade/class-bg.png") no-repeat center center / 100% 100%;
        width: 100%;
        height: 17px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 5px;
        margin-top: 10px;

        .week-left {
          background: url("../../../assets/images/grade/icon-week.png") no-repeat center center / 100% 100%;
          width: 63px;
          height: 20px;
          padding: 0 5px;
          display: flex;
          align-items: center;

          .week-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 600;
            font-size: 12px;
            color: #FFFFFF;
          }

        }

        .week-right {
          position: relative;
          display: flex;
          align-items: center;

          .down-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #000000;
            margin-right: 6px;
          }

          .icon-down {
            width: 11px;
            height: 5px;

          }
        }
      }

      .week-box {
        position: relative;
        padding: 8px 8px 12px 8px;

        .day-box {
          position: relative;

          // min-height: 200px;
          &::before {
            content: "";
            position: absolute;
            border-left: 1px dashed #EB1700;
            left: 14px;
            top: 0;
            width: 1px;
            height: 100%;
          }

          .day-item {
            display: flex;
            flex-direction: column;
            position: relative;
            margin-top: 10px;

            .icon-doast {
              position: absolute;
              left: 8px;
              top: 0;
              width: 13px;
              height: 13px;
            }

            .day-item-box {
              position: relative;
              padding: 0 22px 0 24px;

              .day-num {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 14px;
                color: #EB1700;
                margin-bottom: 2px;
              }

              .day-main {
                // height: 40px;
                background: #F2F7FA;
                border-radius: 4px;
                padding: 8px 11px;
                box-sizing: border-box;
                margin-bottom: 10px;

                .box-title {
                  position: relative;
                  font-family: Source Han Sans CN, Source Han Sans CN;
                  font-weight: 400;
                  font-size: 14px;
                  color: #000000;
                }
              }
            }

            .day-num {}
          }
        }
      }
    }
  }

  .confirm-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    font-size: 16px;
    text-align: center;
    line-height: 42px;
    font-weight: 500;
    color: #fff;
    background-color: #eb1700;
  }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  position: relative;
  top: 250px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/courseSchedule.vue